import { apiClient } from '@/utils/api-client'

const API_BASE = import.meta.env.VITE_API_BASE
const API_INTERNAL_BASE = '/auth/register'

/**
 * Auth register service for account creation and confirmation.
 */
class AuthRegisterService {
    /**
     * Confirm account registration with token and set password.
     *
     * @param {string} id - User ULID
     * @param {string} token - Verification token
     * @param {Object} account - Password payload
     * @param {string} account.password - New password
     * @param {string} account.confirm_password - Password confirmation
     * @returns {Promise<Object>} Confirmation response
     */
    async confirm(id, token, account) {
        await apiClient.get(API_BASE + '/sanctum/csrf-cookie')

        const response = await apiClient.put(
            API_INTERNAL_BASE + '/' + id + '/' + token,
            {
                password: account.password,
                confirm_password: account.confirm_password,
            }
        )

        return response.data
    }
    /**
     * Create a new account registration request.
     *
     * @param {Object} account - Account registration details
     * @param {string} account.company_name - Company name
     * @param {string} account.first_name - First name
     * @param {string} account.last_name - Last name
     * @param {string} account.email - Email address
     * @returns {Promise<Object>} Registration response
     */
    async create(account) {
        await apiClient.get(API_BASE + '/sanctum/csrf-cookie')

        const response = await apiClient.post(API_INTERNAL_BASE, {
            company_name: account.company_name,
            first_name: account.first_name,
            last_name: account.last_name,
            email: account.email,
            device_name: 'app-web',
        })

        return response.data
    }
}

export default new AuthRegisterService()
